import { WxOrderInfo } from "@/types/payment";

export function replaceUrlSearch(search: string) {
  let s = decodeURIComponent(search);
  const match1 = "isFromPayPage=true&";
  const match2 = "&isFromPayPage=true";
  const match3 = "&wcpayRequestMsg=";

  if (s.match(match1)) {
    s = s.replace(match1, "");
  } else if (s.match(match2)) {
    s = s.replace(match2, "");
  }

  if (s.match(/&wcpayRequestMsg=*&/gi)) {
    s = s.replace(/&wcpayRequestMsg=*&/gi, "");
  } else if (s.match(match3)) {
    s = s.replace(match3, "");
  }

  return encodeURI(s);
}

export function convertOrderStr2Obj(info: string): WxOrderInfo {
  const arr = info.split("&");
  const res: Partial<WxOrderInfo> & { [key: string]: string } = {};
  arr.forEach((item) => {
    const index = item.indexOf("=");
    if (index > -1) {
      const key = item.slice(0, index);
      const value = item.slice(index + 1);
      res[key.toLowerCase()] = value;
    }
  });
  res["packageValue"] = res["package"];
  // 兼容 package 字段
  if (!res["package"]) res["package"] = res["packageValue"];
  return res as WxOrderInfo;
}
